import React from 'react';
import Icon from 'components/Icon';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { AssetAlignmentType } from 'const';
import { TEXT_VERTICAL_ALIGNMENTS } from '../const';
import styles from './styles.module.scss';

type Props = {
  alignment: AssetAlignmentType;
  toggleAlignment: (alignment: AssetAlignmentType) => void;
  dataTestId?: string;
};

const TextVerticalAlignment: React.FunctionComponent<Props> = (props) => {
  const {
    alignment,
    toggleAlignment,
    dataTestId = 'textVerticalAlignment',
  } = props;

  return (
    <Dropdown className={styles.TextVerticalAlignment} dataTestId={`${dataTestId}-dropdown`}>
      {TEXT_VERTICAL_ALIGNMENTS.map((
        ({ icon, hint, type }, index) => (
          <div
            className={styles.item}
            key={type}
            onClick={toggleAlignment.bind(null, type)}
            data-testid={`${dataTestId}-item${index}`}
          >
            <Icon type={icon} size="badge" color={type === alignment ? 'primary' : 'secondary'} />
            <span className={styles.hint} data-testid={`${dataTestId}-type-${type}`}>{hint}</span>
          </div>
        )
      ))}
    </Dropdown>
  );
};

export default TextVerticalAlignment;
